import React, {useState, useEffect} from "react";

export default function BerufsmantelPrimoFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M393.7212219,306.5559692c-0.2244263-2.2859497-3.772583-38.685791-5.7991333-46.7996826
	c-2.1177368-8.4708252-4.9008789-28.6940918-5.6021118-36.4286499c-0.5686646-6.2548828-7.2232666-41.4423218-10.4138794-58.348877
	c-0.72229-3.8216553-1.2411499-6.5493774-1.4164429-7.545166c-1.0231323-5.6581421-15.7635498-61.307312-20.0971069-71.4196777
	c-4.12323-9.6130981-10.0268555-17.1099243-11.5842285-18.3300171c-0.0140381-0.0133057-0.0350952-0.0554199-0.0631104-0.0982056
	c-0.0350952-0.069397-0.0911865-0.1682739-0.1893311-0.2377319l-0.2174072-0.1689453
	c-1.0160522-0.7573242-3.5825195-2.6787109-4.319519-3.2116089c-4.9436646-3.6183472-9.87323-6.5775146-15.0693359-9.0528564
	c-5.3012695-2.5307007-10.8759766-4.5930176-16.5488892-6.114624c-2.7347412-0.7355957-4.1715698-1.156311-5.8271484-1.6401978
	c-1.0588379-0.3092651-2.2369385-0.6450806-3.9198608-1.1226807c-0.1465454-0.4831543-0.3015137-0.9599609-0.4838257-1.4375
	c-1.4235229-3.7858887-3.4780884-7.5101318-5.1049194-10.3220215c-2.0062256-3.4780273-4.2354126-6.7310791-6.6195679-9.6698608
	c-0.8063965-0.9957275-1.8862915-2.1660767-3.1414795-2.3561401l-0.6170654-0.0911255
	c-0.6584473-0.0911865-1.3182983-0.1885986-1.977478-0.2728271c-6.3671265-0.8561401-18.322998-0.9543457-25.4615021-1.0174561
	l-1.9494019-0.0139771l-0.8554688,0.0076904c-6.6616211,0.0623779-13.5476685,0.1255493-20.2303467,1.0237427
	c-0.6591187,0.0842285-1.3112793,0.1816406-1.9703979,0.2728271l-0.6661987,0.0981445
	c-1.2131348,0.1830444-2.2929688,1.3533936-3.0994263,2.3491211c-2.3848267,2.9387817-4.6069946,6.1918335-6.6195068,9.6698608
	c-1.6268921,2.8118896-3.6814575,6.5361328-5.1049194,10.3220215c-0.2314453,0.6241455-0.4277344,1.2481689-0.6101074,1.8800049
	c-2.0545654,0.4831543-2.1036377,0.5048828-2.4262085,0.616394c-0.2461548,0.0770874-0.6451416,0.2173462-2.2719727,0.6801758
	c-4.0531006,1.1366577-8.1194458,2.3771362-12.0883789,3.6884155l-0.2041016,0.0631104
	c-3.6954346,1.2201538-7.5241089,2.4753418-11.0653076,4.2501221c-8.0640869,4.0320435-16.4016113,10.9454346-16.4016113,11.8850708
	c-0.0350952,0.2391357-0.8695679,1.6268311-1.8435669,3.2403564c-2.3287354,3.8637695-6.2345581,10.3283691-9.0527954,16.9058228
	c-4.0117188,9.3613281-21.8508301,64.9473877-22.8465576,70.2416382
	c-1.0097656,5.3994751-9.0317917,57.5993042-9.7260056,65.2769775c-0.7012329,7.6644287-3.5271606,30.9100342-5.6098022,39.2335205
	c-2.0258179,8.0991821-6.2268677,41.8140259-6.4933472,43.987854c-0.0981445,0.0770874-0.1612549,0.1893311-0.1682739,0.3295898
	c-0.0210571,0.2180176,0.0981445,0.4074097,0.2874756,0.4697876c13.2041016,4.5579834,26.2819138,5.7227173,34.8929367,5.7227173
	c4.6491089,0,7.9939575-0.3442993,9.34729-0.6668701c0.4207764-0.0974731,0.715271-0.4698486,0.7791138-0.9466553h0.0203247
	c0.0631104-0.4971924,6.5774536-49.562561,8.4574585-54.8070068c1.4718628-4.1029053,7.5725098-37.7616577,9.5787354-48.8262939
	l0.328186-1.7958374c0.295166-1.612793,0.9754028-4.2837524,1.8308716-7.6643677h0.0077515
	c-0.4074097,13.0224609-0.828186,25.8548584-0.8352051,26.0925903l-18.5263062,227.1195679
	c-0.0140381,0.0918579-1.1570435,9.4595337-1.0518799,14.368103c0.0701294,3.0924072,4.3335571,5.6098022,7.895813,7.1741943
	c2.4542847,1.0792236,5.0838623,1.7804565,7.8046265,2.0749512l18.4141235,2.0265503
	c2.8673096,0.3162231,5.7360229,0.6247559,8.6040649,0.9326172c5.6581421,0.6107788,11.5140991,1.2411499,17.2640991,1.9150391
	c4.1940308,0.4901733,8.0360718,0.7355957,11.7034912,0.7355957c0.4277344,0,0.8554688-0.007019,1.2761841-0.0140381h0.2945557
	c3.8076172-0.0560913,7.4119263-0.1192017,10.7925415-1.8856201c0.5742798,0.7426147,1.2832031,1.3807373,1.696228,1.6612549
	c0.2805176,0.1893311,0.7363281,0.1829834,1.1086426,0.175293c0.0974731,0,0.1956787,0,0.2650757,0.0076904
	c0.9620972,0.0413818,1.901001,0.062439,2.9465332,0.0771484c1.9487305,0.0273438,3.9128418,0.0420532,5.8187866,0.0420532
	c1.9430542,0,3.8363647-0.0147095,5.6098022-0.0217285c1.4592438-0.0062866,2.9107819-0.0062866,4.3623199-0.0062866
	c5.4274902,0,11.0162354,0.0062866,16.5629272-0.4698486c8.4924927-0.729248,17.1028442-1.5847778,25.5946655-2.5531616
	c4.2564087-0.4831543,8.5549316-1.0090332,12.7692871-1.5490112c1.2481689-0.1549683,2.517395-0.2874756,3.7375488-0.4213867
	c2.692688-0.2798462,5.4765625-0.5673218,8.1973267-1.1710815c0.3365479-0.0701294,0.708252-0.1465454,1.1079102-0.2313843
	c4.9085693-1.0371094,14.0385132-2.9584961,14.1577148-8.4988403c0.0841675-3.5264893-0.4768066-9.2631836-0.8134155-12.3766479
	c-0.1542358-1.4024048-0.2524414-2.8399658-0.2874756-4.2907715l-15.3638306-227.5831299v-30.4043579
	c1.0097656,5.0410767,1.8231812,9.5990601,2.3427734,12.4957886l0.3078613,1.7173462
	c1.430481,7.8607178,10.9811401,47.220459,12.4677734,51.357666c1.4366455,4.0102539,6.6227417,33.512207,9.0237427,47.4070435
	c-0.0953979,0.0543823-0.194458,0.1020508-0.2886353,0.1586304l0.3098755-0.0354614
	c0.7276001,4.2114868,1.1942749,6.9595947,1.2139282,7.0740967h0.0209961
	c0.0631104,0.4768677,0.357666,0.8422241,0.7783813,0.9396973c1.4438477,0.3505859,4.5439453,0.6598511,8.7793579,0.6598511
	c8.3164673,0,20.9946289-1.1998291,34.0591431-5.7156982c0.1886597-0.0623779,0.3078613-0.25177,0.2944946-0.4697876
	C393.8754578,306.7460327,393.8123474,306.6338501,393.7212219,306.5559692z"
      />
      <path
        fill={darkenColor}
        d="M393.4056091,306.9137573l-0.0210571,0.0077515
	c-19.6279907,6.7808228-38.3359375,6.0578613-42.5783386,5.0410767c-0.3022156-0.069397-0.4277649-0.3639221-0.4487915-0.6170654
	c-0.0210266-0.2594604,0.0701294-0.6030579,0.3849792-0.729248c9.081543-3.7025146,20.0136414-4.670166,28.5966187-4.670166
	C386.3786011,305.946106,391.8348389,306.5982361,393.4056091,306.9137573"
      />
      <path
        fill={darkenColor}
        d="M152.7588806,311.3457947c-0.02034,0.2524414-0.1465607,0.5469666-0.4487915,0.6170959
	c-3.8286896,0.9185791-23.7287292,1.9487-43.9457321-5.0558472c3.1555099-0.6170654,27.4950027-3.0222778,44.0088425,3.7095032
	C152.6887512,310.7427368,152.7799072,311.0863342,152.7588806,311.3457947"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M284.2877808,77.1292343c-2.2362366,1.5925217-24.1291504,17.2361145-33.3713074,27.9227676
	c3.7725983-8.5829849,21.9413147-50.0386429,22.979126-54.3792267c0.1122131-0.4698486,0.2384338-1.0175095,0.3716736-1.6198692
	c1.8238525,3.7515755,4.9997253,13.2314186,5.0558167,13.399704
	C279.4780579,63.0346413,282.4856262,74.3391037,284.2877808,77.1292343"
      />
      <path
        fill={darkenColor}
        d="M275.8867493,39.2631111c-0.799408,3.885498-1.8231812,8.7232361-2.4325562,11.3044624
	c-0.2454224,1.0097656-1.4725647,4.1582565-3.2403564,8.4708061c-17.4037018-2.096653-32.2205658-0.7152634-39.5700989,0.3148308
	c-1.7874146-4.4730873-3.0363007-7.7478371-3.2810364-8.7856369c-0.5960388-2.4753418-1.5917816-7.0262833-2.41922-10.8269081
	C227.2996063,39.256134,249.3110199,34.9793701,275.8867493,39.2631111"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M249.7948761,106.4053574c-0.323288,0.3793716-1.4094696,1.6829605-2.7137451,3.4016495
	c-16.6190186-22.9651031-28.9121857-31.5831375-30.5670776-32.6917648c1.6766205-2.8673019,4.8103943-14.086895,4.9723816-14.662632
	c0.098175-0.2447243,3.2747192-8.4841118,5.343338-12.1452103c0.0273438,0.1269417,0.0631104,0.2461357,0.0834351,0.3653755
	C228.0358734,55.3429108,248.3215942,102.9553452,249.7948761,106.4053574"
      />
      <path
        fill={darkenColor}
        d="M270.0317993,59.4726219c-6.0866394,14.774807-18.2248383,42.4311028-19.9701843,46.4000587
	c-1.6836395-3.9478989-13.2889099-31.231842-19.2422943-46.0844994
	C238.1688538,58.7713966,252.8167267,57.4180374,270.0317993,59.4726219"
      />
      <path
        fill="#010101"
        d="M250.0612793,151.2206421c-1.7881317,0-3.2396698,1.4515381-3.2396698,3.2396545
	s1.4515381,3.2396545,3.2396698,3.2396545c1.7810974,0,3.2396545-1.4515381,3.2396545-3.2396545
	S251.8423767,151.2206421,250.0612793,151.2206421 M250.0612793,157.2441406c-1.5356903,0-2.7838593-1.2474823-2.7838593-2.783844
	c0-1.5350037,1.2481689-2.7831573,2.7838593-2.7831573c1.5349731,0,2.783844,1.2481537,2.783844,2.7831573
	C252.8451233,155.9966583,251.5962524,157.2441406,250.0612793,157.2441406"
      />
      <path
        fill="#CFCFCE"
        d="M252.844986,154.4604645c0,1.5356903-1.2481995,2.7838898-2.7838593,2.7838898
	c-1.535675,0-2.7831573-1.2481995-2.7831573-2.7838898c0-1.5349579,1.2474823-2.783844,2.7831573-2.783844
	C251.5967865,151.6766205,252.844986,152.9255066,252.844986,154.4604645"
      />
      <path
        fill="#010101"
        d="M250.0612793,228.8536835c-1.7881317,0-3.2396698,1.4585419-3.2396698,3.2396545
	c0,1.7881165,1.4515381,3.2466736,3.2396698,3.2466736c1.7810974,0,3.2396545-1.4585571,3.2396545-3.2466736
	C253.3009338,230.3122253,251.8423767,228.8536835,250.0612793,228.8536835 M250.0612793,234.884201
	c-1.5356903,0-2.7838593-1.2551727-2.7838593-2.790863c0-1.535675,1.2481689-2.7838593,2.7838593-2.7838593
	c1.5349731,0,2.783844,1.2481842,2.783844,2.7838593C252.8451233,233.6290283,251.5962524,234.884201,250.0612793,234.884201"
      />
      <path
        fill="#CFCFCE"
        d="M252.844986,232.0929871c0,1.535675-1.2481995,2.7908783-2.7838593,2.7908783
	c-1.535675,0-2.7831573-1.2552032-2.7831573-2.7908783c0-1.5349884,1.2474823-2.783844,2.7831573-2.783844
	C251.5967865,229.3091431,252.844986,230.5579987,252.844986,232.0929871"
      />
      <path
        fill="#010101"
        d="M250.0612793,303.4493103c-1.7881317,0-3.2396698,1.4515381-3.2396698,3.2403564
	c0,1.7874146,1.4515381,3.2389526,3.2396698,3.2389526c1.7810974,0,3.2396545-1.4515381,3.2396545-3.2389526
	C253.3009338,304.9008484,251.8423767,303.4493103,250.0612793,303.4493103 M250.0612793,309.4735107
	c-1.5356903,0-2.7838593-1.2481689-2.7838593-2.783844s1.2481689-2.783844,2.7838593-2.783844
	c1.5349731,0,2.783844,1.2481689,2.783844,2.783844S251.5962524,309.4735107,250.0612793,309.4735107"
      />
      <path
        fill="#CFCFCE"
        d="M252.844986,306.6898804c0,1.5349731-1.2481995,2.783844-2.7838593,2.783844
	c-1.535675,0-2.7831573-1.2488708-2.7831573-2.783844c0-1.535675,1.2474823-2.7845459,2.7831573-2.7845459
	C251.5967865,303.9053345,252.844986,305.1542053,252.844986,306.6898804"
      />
      <path
        fill="#010101"
        d="M263.356781,132.799881v57.4933929l4.6771545,8.6734467h47.5360107l4.0734253-8.7225342
	l0.0210266-57.4443054H263.356781z M319.2093201,190.0969086l-3.9275818,8.4147034h-46.9820251l-4.4871216-8.2744446V133.255661
	h55.3967285V190.0969086z"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        points="
	317.8061523,134.6563568 317.8061523,189.7838135 314.3883667,197.1074066 269.1404724,197.1074066 265.214325,189.8791962 
	265.214325,134.6563568 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M238.8426666,478.944397c-0.0014038-3.6673889-0.2798004-21.7267456-0.3071442-25.3948364
	c-0.0077209,0.3786621-0.0147247,0.7573242-0.0224457,1.1359863c0.1914368-22.8143311,0.536438-45.625885,0.8344727-68.4388123
	c0.2945099-22.5394592,0.5946198-45.0782166,0.901062-67.6176758c0.2875061-21.1889038,0.5806274-42.3764038,0.8814392-63.5653076
	c0.2636719-18.5144348,0.5336304-37.0288544,0.816925-55.5425873c0.22229-14.5167542,0.4508972-29.0349121,0.7040405-43.5509491
	c0.1612701-9.1965485,0.3183441-18.3931122,0.5448456-27.5882416c0.0631104-2.5805511-0.0497894-10.1053619,0.2748871-12.6718674
	 M339.8961182,458.7028503c-2.0335693,3.0033569-10.6046143,5.5509033-13.7832642,6.2191772
	c-0.3218689,0.0715027-0.6016541,0.1304016-0.8569031,0.1837158l-0.2622681,0.0546875
	c-2.5727844,0.5686951-5.2493591,0.8491821-7.8389587,1.1212769l-0.0862732,0.0090942
	c-1.1451111,0.1164246-2.4830322,0.2566528-3.8062439,0.4263611c-4.2851868,0.5476379-8.5682678,1.0658569-12.7328491,1.5391846
	c-8.4876099,0.9704895-17.0740967,1.8287964-25.5224609,2.5538635c-5.3531494,0.4543762-10.9257813,0.4543762-15.8434753,0.4543762
	h-0.5048523c-1.4543457,0-2.9100952,0-4.3721466,0.0077209c-1.7425537,0.0098267-3.6000824,0.0210266-5.5109253,0.0210266
	c-2.1829071,0-4.1014557-0.0133057-5.8671417-0.0420532c-0.6654663-0.0084229-2.818924,0.0588989-3.3904114,0.0420532"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M235.467041,471.2646484c-4.9176788,0-10.4903259,0-15.8434753-0.4543762
	c-8.4483337-0.7250671-17.0348358-1.583374-25.5224609-2.5538635c-4.1645813-0.4733276-8.4476471-0.9915161-12.732132-1.5391846
	c-1.3239136-0.1704102-2.66185-0.3099365-3.8069458-0.4263306l-0.0862427-0.0091248
	c-2.5896301-0.2720947-5.2662048-0.5532837-7.8389893-1.1212769l-0.2622681-0.0546875
	c-0.255249-0.0532837-0.5350342-0.1121826-0.8569031-0.1837158c-3.1786499-0.6682739-11.7490082-3.2158203-13.7832489-6.2191467"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M256.4462891,478.9445496c-0.0007324-3.6674194-0.2791138-21.7267456-0.3064575-25.3948669
	c-0.0077209,0.3786621-0.0147095,0.7573242-0.0224609,1.1352844c0.1914673-22.8136292,0.5357666-45.6251526,0.8344727-68.4381104
	c0.2945251-22.5394592,0.5939636-45.078186,0.9003601-67.6176758c0.2875061-21.1888733,0.5806274-42.3770752,0.8821411-63.5652771
	c0.2636719-18.5144348,0.532959-37.0288544,0.816925-55.5426025c0.2216187-14.5174408,0.4501953-29.0348816,0.7040405-43.5509186
	c0.1605835-9.1965485,0.3183594-49.7645111,0.5441589-58.9589691"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M109.1398392,298.7175598c0,0,8.6741409-1.667511,14.7579651-1.3498535c0,0,20.3916092,0.7713623,29.9906693,6.5319214"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M392.5057068,299.3742676c-6.8201294-1.3000488-13.5722046-1.5805664-20.4715576-0.7594299
	c-4.0839233,0.4859619-8.180481,1.1086426-12.2034302,1.9655151c-3.5474854,0.755249-7.198761,1.6450806-10.4517517,3.2950745
	c-0.3400574,0.1717834-0.6745605,0.354126-1.0013428,0.5504761"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M230.1791077,57.5640717c7.9294434-1.1149254,22.9482727-2.467598,40.6366577-0.3099098"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M230.1791077,56.8368225c7.9294434-1.1149216,22.9482727-2.4675941,40.6366577-0.3106384"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M224.6713409,38.3503304c0,0,23.0148926-5.1280479,51.4881134-0.4943314"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        x1="265.723114"
        y1="141.3700256"
        x2="316.8087158"
        y2="141.3700256"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M212.1376495,262.0689697v82.3300781c0,0.9704895-0.3730621,1.8919067-1.0518341,2.5959473l-6.3439789,6.5473328
	c-0.6970215,0.7229614-1.6710205,1.1366577-2.6730652,1.1366577c-0.2769928-0.0007019-26.4473877-0.1949158-38.0877075-2.6078491"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M211.157074,271.0184937c-0.5189209,0-23.1663666-0.20755-40.4108887-2.1807861"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M211.157074,324.6402283c-0.5778198,0-25.8015594-0.20755-45.0081024-2.181488"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M284.4521484,262.0689697v82.3300781c0,0.9704895,0.3730164,1.8919067,1.0518188,2.5959473l6.3439941,6.5473328
	c0.696991,0.7229614,1.67099,1.1366577,2.6730347,1.1366577c0.2770081-0.0007019,26.4473877-0.1949158,38.087738-2.6078491"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M285.4320374,271.0184937c0.5195923,0,23.1663208-0.20755,40.4115295-2.1807861"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M285.4320374,324.6402283c0.5784912,0,25.8022461-0.20755,45.0087585-2.181488"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.315551"
        strokeMiterlimit="10"
        strokeDasharray="0.9417446,0.9410433"
        d="
	M221.2696381,60.6589775c-1.2278595-0.3793755-2.6639557-0.5743256-4.2648468-0.5743256
	c-3.3329315,0-6.8032837,0.8435745-9.0079346,1.5048256c0.0946655-2.3645363,0.313446-4.6357689,0.5273285-6.6174202
	c0.3814545-3.5377083,1.2558899-8.3516083,1.9578094-11.4882011 M247.1272888,107.4720001
	c-14.2832489-19.4175873-25.3408508-28.2782516-28.8091125-30.8061981
	c1.8694611-4.193306,4.5046692-13.7509995,4.5334167-13.8554726l0.4017944-1.4543648l-0.5132904-0.1822815 M278.3422852,61.0853004
	l-0.7622375,0.2706642l0.4031982,1.4613838c0.021759,0.0841408,2.5314331,9.6909294,4.5004578,13.889843
	c-4.1182861,2.952858-17.6792603,12.8534546-27.1576996,21.8115768 M290.3844299,45.2516403
	c1.1352844,3.0096931,1.543396,6.1827087,1.9248657,9.720417c0.1885986,1.696949,0.4270325,4.07621,0.5272827,6.6174202
	c-2.2032166-0.6598396-5.6721802-1.5013161-9.0114136-1.5013161c-1.5216675,0-2.8939514,0.1753044-4.0930481,0.5217247"
      />
      <path
        fill="#010101"
        d="M393.6648254,306.5559998c-0.2243958-2.2859497-3.772583-38.6858215-5.7991333-46.7997131
	c-2.1176758-8.4707947-4.9008484-28.6941071-5.6020813-36.4286194c-0.5686951-6.2548981-7.2232971-41.4423676-10.4138794-58.348877
	c-0.7222595-3.8216858-1.2411499-6.549408-1.4164734-7.5451813c-1.0231018-5.6581573-15.7635193-61.3073273-20.0970764-71.4197006
	c-4.12323-9.6130753-10.026825-17.1098938-11.5842285-18.3300171c-0.0140381-0.0133133-0.0350952-0.0553818-0.0631104-0.0981827
	c-0.0350647-0.0694199-0.091156-0.1682892-0.1893616-0.237709l-0.2173767-0.1689682
	c-1.0160522-0.7573395-3.58255-2.678688-4.319519-3.2116241c-4.943634-3.6183395-9.8732605-6.5774879-15.0693359-9.0528297
	c-5.301239-2.5306854-10.8759766-4.5930138-16.5488892-6.1146584c-2.7347717-0.7355919-4.1716003-1.156311-5.827179-1.6401558
	c-1.0588379-0.309269-2.236908-0.6451149-3.9198303-1.1226692c-0.1465454-0.4831619-0.3015137-0.9599915-0.4838562-1.4375038
	c-1.4234924-3.7859001-3.4780579-7.510128-5.1049194-10.3220444c-2.0061951-3.4780483-4.2353821-6.7310543-6.6195374-9.6698723
	c-0.806427-0.9957256-1.886322-2.1660748-3.1414795-2.3561039l-0.6170959-0.0911617
	c-0.6584473-0.0911636-1.3182983-0.1886177-1.9774475-0.2728043c-6.3671265-0.8561573-18.322998-0.95434-25.4614563-1.0174675
	l-1.9494019-0.0139961l-0.8554993,0.0077038c-6.6616364,0.0624008-13.5476532,0.1255302-20.2303162,1.0237598
	c-0.6591644,0.0841866-1.3113098,0.1816406-1.9704437,0.2728043l-0.6661682,0.0981808
	c-1.2131195,0.1830101-2.2929993,1.3533592-3.099411,2.3490849c-2.3848724,2.938818-4.6070404,6.191824-6.6195679,9.6698723
	c-1.6268463,2.8119164-3.681427,6.5361443-5.1049194,10.3220444c-0.2313843,0.6240997-0.4277344,1.2481575-0.6100616,1.8799629
	c-2.0545807,0.4831619-2.1036682,0.5049019-2.4262238,0.616394c-0.2461395,0.0771255-0.6451416,0.2173805-2.2719879,0.6801682
	c-4.0530701,1.1367073-8.1194611,2.3771629-12.0883942,3.6884499l-0.204071,0.0631294
	c-3.6954346,1.2201233-7.5241241,2.4752998-11.0653229,4.250103c-8.0640717,4.0320396-16.4016266,10.9454155-16.4016266,11.8850746
	c-0.0350647,0.2391205-0.8695221,1.6268082-1.8435211,3.2403412c-2.3287659,3.8637543-6.2345886,10.3283386-9.0528107,16.9058304
	c-4.0117035,9.3613281-21.8508606,64.9474106-22.8465881,70.2416458
	c-1.0097656,5.3994293-9.0317688,57.5992737-9.7259979,65.2769775c-0.7012253,7.6644135-3.5271606,30.9099884-5.6097946,39.2335205
	c-2.0258255,8.0991516-6.22686,41.8140259-6.4933243,43.9878235c-0.0981827,0.0771179-0.161293,0.1893311-0.1683121,0.3295898
	c-0.0210342,0.2180481,0.0981827,0.4074097,0.2875061,0.4697876c13.204071,4.5579834,26.2818985,5.7227173,34.8929367,5.7227173
	c4.6491241,0,7.9939575-0.3442993,9.3473206-0.6668701c0.4207306-0.0974731,0.7152557-0.4698181,0.779068-0.9466553h0.02034
	c0.0630951-0.4971619,6.5774841-49.562561,8.4574585-54.8070068c1.4718781-4.1028595,7.5725098-37.7616425,9.5787354-48.8262787
	l0.3281708-1.7958221c0.2951965-1.6128235,0.9753876-4.283783,1.8308868-7.6643982h0.0077209
	c-0.4074097,13.0224609-0.8281403,25.8548584-0.8351593,26.0925751l-18.5263367,227.1196136
	c-0.0140381,0.0918579-1.1570435,9.4595032-1.0518494,14.3680725c0.0701141,3.0924072,4.3335724,5.6098022,7.8957825,7.1742249
	c2.4542847,1.0791931,5.0838776,1.780426,7.8046265,2.0749207l18.4141693,2.0265503
	c2.8672943,0.3162537,5.7360077,0.6247864,8.6040192,0.9326172c5.6581726,0.6107788,11.5141144,1.2411804,17.2641449,1.9150391
	c4.1940155,0.4901733,8.036026,0.7355957,11.7034302,0.7355957c0.4277496,0,0.8554993-0.007019,1.2762299-0.0140076h0.2945251
	c3.8076477-0.0561218,7.4119415-0.1192322,10.7925415-1.8856201c0.5743103,0.7426147,1.2832489,1.3807373,1.6962585,1.6612244
	c0.2805023,0.1893311,0.7362823,0.1830139,1.1086426,0.175293c0.0974579,0,0.1956329,0,0.2650604,0.0077209
	c0.9620819,0.0413818,1.9010162,0.0624084,2.9465485,0.0771179c1.9487,0.0273743,3.9128265,0.0420837,5.8187561,0.0420837
	c1.9430847,0,3.8363953-0.0147095,5.609787-0.0217285c1.4592438-0.0063171,2.9107971-0.0063171,4.3623352-0.0063171
	c5.4274597,0,11.0162354,0.0063171,16.5629272-0.4698181c8.4925232-0.7292786,17.1028442-1.5847778,25.5946655-2.5531616
	c4.2564392-0.4831543,8.5549316-1.0090637,12.7693176-1.5490112c1.2481689-0.1549683,2.517395-0.2875061,3.7375183-0.4214172
	c2.6927185-0.2798157,5.4765625-0.5672913,8.1972961-1.171051c0.3366089-0.0701294,0.708252-0.1465454,1.1079407-0.2314148
	c4.9085999-1.0371094,14.0385132-2.9584656,14.1577454-8.4988403c0.084137-3.5264587-0.4768677-9.2631836-0.8134155-12.3766174
	c-0.1542969-1.4024353-0.2524719-2.8399658-0.2875061-4.290802l-15.3638306-227.5830841v-30.4044037
	c1.0097656,5.0411072,1.8231812,9.5990601,2.3427734,12.4958344l0.3078308,1.7173004
	c1.4305115,7.8607178,10.9812012,47.220459,12.4677734,51.357666c1.8792725,5.2458801,10.1747742,54.1135254,10.2589111,54.6043396
	h0.0210571c0.0631104,0.4768677,0.3576355,0.8421936,0.7783508,0.9396667
	c1.4438171,0.3505859,4.5439453,0.6598511,8.7793274,0.6598511c8.3165283,0,20.9946594-1.1997986,34.0591736-5.7156982
	c0.1886292-0.0623779,0.3078308-0.2517395,0.2945251-0.4697876
	C393.8190918,306.7460327,393.756012,306.6338501,393.6648254,306.5559998 M296.3839417,47.600811
	c1.6618958,0.4838448,3.0994263,0.8975868,5.841217,1.6345482c5.6525574,1.5209618,11.1915588,3.5685692,16.4717712,6.0929604
	c5.1679993,2.4613037,10.0765991,5.4071388,14.999176,9.0037422c0.7292786,0.5399094,3.2957458,2.4619904,4.3125305,3.2115784
	l0.2174072,0.1682816c0.0210266,0.0147705,0.0420532,0.0490952,0.0630798,0.0841904
	c-0.3716431,1.3049469-0.7222595,2.6015167-1.0588379,3.9065094c-0.3435974-0.4635162-0.8484802-0.9894333-0.9326172-1.0735779
	c-0.7012329-0.7075577-1.5286865-1.408783-2.5314331-2.1527634c-6.4926453-4.7963982-12.7903442-8.4287338-19.2416077-11.0926514
	c-5.2731934-2.1745071-10.7981567-3.9205475-16.1421814-5.6097984c-1.6121216-0.5126076-3.2186279-1.0237999-4.8314209-1.5497208
	c-0.2033691-1.2488823-0.4621277-2.4760284-0.799408-3.6681175
	C294.2802734,46.9844551,295.3882141,47.3069916,296.3839417,47.600811 M209.1235962,44.7615852
	c1.4094391-3.7592773,3.4500122-7.4540176,5.0698547-10.2589149c1.9991913-3.4500561,4.2150421-6.6903954,6.5844879-9.6067848
	c0.7503052-0.9333267,1.753067-2.0265503,2.8469696-2.1885452l0.6240997-0.090435
	c0.6591492-0.0981808,1.3112793-0.1970482,1.9704285-0.2811909c6.6546326-0.8898411,13.5266266-0.9536552,20.1742401-1.0167847
	l0.8484802-0.007019l1.9423828,0.0210571c7.1314697,0.0567951,19.0662842,0.1542492,25.405365,1.0027466
	c0.6591492,0.0841427,1.3190002,0.1830101,1.9704285,0.2811909l0.6661682,0.090435
	c1.0518494,0.1619949,2.0545959,1.2552185,2.8119202,2.1885452c2.3630981,2.9163895,4.5796814,6.1567287,6.5774841,9.6067848
	c1.619812,2.8048973,3.6604004,6.4996376,5.0705261,10.2589149c1.1843872,3.1407471,1.6121521,6.4154968,2.0048218,10.0618706
	c0.2664795,2.3911591,0.5610046,5.5186348,0.5820313,8.7168999c-1.6759338-0.6030426-9.4595337-3.1982651-14.5854797-1.4382286
	c-0.5188904-1.5419731-3.59729-10.6017838-5.2661743-13.7502747c1.2341309-5.55373,3.0853577-14.7474556,3.1064148-14.8659668
	c0.0280457-0.1970482,0.5539551-4.7753372-1.5560303-7.2226048c-0.8141174-0.9473629-1.90802-1.4452477-3.2613831-1.4803009
	l-0.0133362,0.4558125c1.2194519,0.035738,2.2011414,0.4768276,2.9304199,1.3189907
	c1.9781494,2.2922897,1.4585571,6.8222179,1.45224,6.8502483c-0.0077209,0.0561104-0.4775391,2.391201-1.1016235,5.406456
	c-26.6605682-4.2985077-48.7631531-0.007019-51.1333008,0.4845352c-0.7012177-3.2543793-1.2621918-5.8481903-1.2762146-5.9190216
	c-0.0133209-0.0350533-1.3035889-3.9408798,0.2180786-6.3320789c0.6584473-1.0307808,1.7593689-1.6408424,3.2810364-1.8091297
	l-0.0490875-0.4558125c-1.661911,0.1823254-2.8813324,0.8624935-3.6183319,2.0195293
	c-1.6408539,2.5734825-0.3148346,6.5564346-0.266449,6.6966858c0.0210266,0.1199226,2.3210449,10.9040337,3.5481873,16.1632156
	c-1.92836,3.1912918-5.027771,11.1003952-5.5466919,12.4397163c-5.125946-1.7663727-12.9235687,0.8274841-14.5994873,1.4382286
	c0.0210419-3.1982651,0.3225555-6.3257408,0.582016-8.7168999
	C207.5107727,51.1770821,207.9385223,47.9023323,209.1235962,44.7615852 M226.9136505,50.6721764
	c1.1219635,4.6701813,21.4083862,52.2832985,22.8809509,55.7333565c-0.3225708,0.3793259-1.4087677,1.6829071-2.7137299,3.4009171
	c-16.6190186-22.9651031-28.9114838-31.5831375-30.5663757-32.6910782
	c1.6759338-2.8680267,4.8104095-14.0876236,4.9716797-14.662632c0.098175-0.2447281,3.2747192-8.4841156,5.3433228-12.1451721
	C226.8575592,50.4337845,226.8926239,50.5529823,226.9136505,50.6721764 M224.9432068,39.7401123
	c2.3561096-0.4838486,24.3675385-4.7613449,50.9432678-0.4768295c-0.7987061,3.8854523-1.8224792,8.7232361-2.4318542,11.3044205
	c-0.2461243,1.009079-1.4732666,4.1582565-3.2403564,8.4708061c-17.4043884-2.0966568-32.2212677-0.71595-39.5700989,0.3148308
	c-1.7881165-4.4738159-3.0363007-7.7485237-3.281723-8.7856369
	C226.7671051,48.0924034,225.771347,43.5407372,224.9432068,39.7401123 M230.8194733,59.7880936
	c7.3488312-1.0167809,21.9973907-2.3701401,39.2124786-0.3155594c-6.0866394,14.7748108-18.224823,42.4311066-19.9708862,46.4000549
	C248.3781281,101.9246979,236.7728729,74.6407547,230.8194733,59.7880936 M273.8956909,50.6721764
	c0.1121826-0.4698067,0.2377014-1.0167847,0.3716431-1.6190987c1.8231812,3.7508507,4.9997253,13.2313766,5.0558472,13.399662
	c0.1549683,0.5820274,3.1625061,11.8857613,4.9646606,14.6766701c-2.236908,1.5917435-24.1291504,17.2360611-33.3712769,27.9227219
	C254.6891479,96.4691467,272.8578796,55.013485,273.8956909,50.6721764 M180.233139,56.1845169
	c3.5131378-1.7600784,7.3214874-3.0082359,11.0092316-4.2220688l0.1963348-0.0694199
	c3.9689484-1.3049965,8.0290222-2.5454483,12.0750885-3.681427c1.6408691-0.4635201,2.0475769-0.6037712,2.2929993-0.6879158
	c0.2875061-0.0981827,0.3435974-0.1191978,2.1317291-0.5392303c-0.2798004,1.0581284-0.497879,2.1450195-0.680191,3.2529678
	c-1.5987854,0.518898-3.2045898,1.0237999-4.8104095,1.5286636c-5.3363037,1.6969948-10.8612518,3.4430351-16.1351624,5.6175423
	c-6.4582825,2.6639175-12.7552643,6.2962532-19.2486115,11.0926514c-0.8695221,0.6451111-1.6058197,1.2629166-2.243927,1.8800049
	c-0.2306976-0.8982773-0.4768372-1.7881622-0.7222595-2.6794128
	C164.4345551,66.8003387,172.0428467,60.279644,180.233139,56.1845169 M152.310379,311.9624634
	c-3.8286896,0.919281-23.7294464,1.9494019-43.9457321-5.0558472c3.1555099-0.6163635,27.4950027-3.0215759,44.0088272,3.7102051
	c0.315567,0.1254883,0.406723,0.4691162,0.3856964,0.7292786
	C152.7381287,311.5985107,152.6125946,311.8930359,152.310379,311.9624634 M172.9684601,198.2519073
	c-0.8632202,3.3869019-1.5419922,6.0662689-1.8372192,7.6931152l-0.3295746,1.8014374
	c-2.0047913,11.0513153-8.0991364,44.6820374-9.5576782,48.7568359c-1.7740936,4.9366455-7.4042511,46.8411255-8.351593,53.9382019
	c-0.098175-0.1058655-0.2103729-0.197052-0.3436127-0.2531128c-16.2396545-6.6125793-39.9908295-4.4520874-44.0158463-3.7726135
	c0.4347534-3.499115,4.4878311-35.8536072,6.4582672-43.7423706c2.0903625-8.3438873,4.9226074-31.6252441,5.6168137-39.302948
	c0.7012253-7.6721039,8.716217-59.8424683,9.7259827-65.2356262c0.9887238-5.2872162,18.8061371-60.7961655,22.8178558-70.1504822
	c2.8048859-6.5494537,6.6966858-12.992981,9.0247498-16.8497162c0.8414764-1.3954315,1.353363-2.2516251,1.6338501-2.7705307
	c4.1302185,14.9297409,5.3223114,30.4828949,6.4652863,45.5375214c0.6661682,8.7653046,1.3603821,17.8328171,2.6162872,26.7734299
	c1.2544861,8.8634949,1.247467,20.3355103,1.247467,29.5559082v1.3463745c0,2.4963684-0.3148499,13.4073944-0.6591492,24.6767578
	L172.9684601,198.2519073z M170.2967834,258.053009c17.3623199,2.0125427,41.9262085,2.6148682,42.1786652,2.6218872
	c0.6177673,0,1.1219482,0.4985657,1.1219482,1.1156616v82.6105347c0,1.3393555-0.5189056,2.6015625-1.4445343,3.5692444
	l-6.3460693,6.5494385c-0.9606781,0.9887085-2.2993011,1.5637207-3.681427,1.5637207
	c-0.2804871-0.0063171-28.3645325-0.1816101-39.584137-2.9100647L170.2967834,258.053009z M226.2545013,480.3334656h-0.2945099
	c-4.0320435,0.0638123-8.2604218-0.1676025-12.9165497-0.7152405c-5.7500458-0.6795044-11.6052856-1.3035889-17.2718658-1.9143677
	c-2.8673096-0.3085327-5.7353058-0.6163635-8.6033173-0.9326172l-18.4141693-2.0265503
	c-2.6786804-0.2944946-5.2591705-0.9809875-7.6706848-2.0475464c-3.4430084-1.506958-7.5606079-3.9128418-7.6160126-6.7591248
	c-0.1121826-4.8742065,1.0307922-14.2138062,1.0448303-14.3126831l7.9869385-97.9891052
	c11.3254852,2.7214355,39.3386993,2.896759,39.6262054,2.9037781c1.5013123,0,2.9661865-0.6247864,4.0117188-1.7046814
	l6.3383636-6.5494385c1.0167694-1.0518494,1.5777435-2.426239,1.5777435-3.8847961v-82.6105347
	c0-0.8702393-0.7082367-1.5714417-1.5707397-1.5714417c-0.2454224-0.0063171-24.8086243-0.6100769-42.1435852-2.6225891
	l2.699707-33.1118164c0.007019-0.2594757,0.4768372-14.4655762,0.8975525-28.1611786l0.0911713-0.3639374l-0.0834351-0.0217438
	c0.3428802-11.1564941,0.6514282-21.884491,0.6514282-24.3605194v-1.3463745c0-9.2351227,0.007019-20.7204437-1.2481842-29.6197205
	c-1.2621918-8.9258881-1.9494019-17.9794083-2.6155548-26.7447128c-1.0805969-14.1927719-2.2018585-28.8406372-5.7850952-42.9990921
	c0.666153-0.6654434,1.444519-1.3252792,2.391861-2.0194855c6.4575806-4.7816696,12.726532-8.3929939,19.1497498-11.0365829
	c5.2514648-2.1745033,10.7714996-3.9205475,16.1001129-5.6097946c1.528656-0.4838448,3.0573273-0.9684219,4.5860138-1.4585571
	c-0.2033691,1.297245-0.3583374,2.6366081-0.5112,4.0320396c-0.2671661,2.4816322-0.5820313,5.75634-0.5820313,9.0871582v0.3366127
	l0.3078461-0.1192398c0.091156-0.0343246,9.115921-3.4493256,14.6065063-1.556694
	c-0.4557953,1.6134949-3.4857941,12.2573929-4.9779816,14.5363693l-0.1339417,0.1963654l0.2033539,0.1262131
	c0.1262207,0.0778122,12.9235687,8.2043381,30.7066193,32.8032608c-2.3000183,3.0713654-5.1252441,7.2576981-5.6448517,9.9503784
	c-0.8765411,4.5376282-4.8244171,316.9892273-4.9927216,330.2977905c0.0350647,1.4171753,0.0631104,3.7592773,0.0070038,3.9906616
	c-0.0280457,0.1255188-0.0210266,1.4367981,0.0210571,6.5767822c0.0497742,5.8902893,0.1262054,14.7958374-0.0210571,15.5678711
	c-0.1121826,0.5953674,0.1823273,1.2966003,0.6240997,1.955719
	C233.5121765,480.2219849,229.9850159,480.2773743,226.2545013,480.3334656 M324.0682983,168.7513885v19.7822418
	l-0.1051636,0.0203247c0.0350342,0.1682892,0.0700989,0.3372803,0.1051636,0.5055847v32.6483154l8.8782043,131.5847778
	c-11.2763977,2.699707-38.2314758,2.7845459-38.5049438,2.790863c-1.3814087,0-2.7207336-0.5750122-3.681427-1.5637207
	l-6.3460693-6.5494385c-0.9256287-0.9676819-1.4375305-2.2298889-1.4375305-3.5692444v-82.6105347
	c0-0.6170959,0.4978638-1.1156616,1.1219788-1.1156616c0.2454224-0.007019,25.0336914-0.6163635,42.4030457-2.6499329
	l-0.0491028-0.4494934c-17.3475952,2.0272522-42.1155396,2.6373291-42.36026,2.6436462
	c-0.8702087,0-1.5714417,0.7012024-1.5714417,1.5714417v82.6105347c0,1.4585571,0.5532532,2.8329468,1.5714417,3.8847961
	l6.3383789,6.5494385c1.0447998,1.079895,2.510376,1.7046814,4.0109863,1.7046814
	c0.273468-0.007019,27.1584167-0.0918884,38.5393066-2.7845764l6.4519653,95.5418396
	c0.0343628,1.4515381,0.1325378,2.9100647,0.2875061,4.3195496c0.3358765,3.0993958,0.8898621,8.8214111,0.8127136,12.3211975
	c-0.1115112,5.1743469-9.0107117,7.0466003-13.7930908,8.0570679c-0.4067078,0.0834656-0.7783508,0.1605835-1.1149292,0.2384338
	c-2.6997375,0.5953369-5.469574,0.882843-8.1412354,1.164032c-1.2341309,0.1255188-2.5040588,0.2587585-3.7515259,0.4200134
	c-4.214386,0.5399475-8.5128784,1.0588684-12.7693176,1.543396c-8.4848022,0.9670105-17.0958252,1.8302002-25.5799866,2.5517578
	c-5.5263367,0.4768372-11.1221008,0.4698486-16.5215149,0.4698486c-1.4515381,0-2.9030914,0-4.3686371,0.0069885
	c-3.506134,0.0210266-7.4820709,0.0420837-11.4159393-0.0203247c-1.0378113-0.01474-1.9774475-0.0280457-2.9241028-0.0778503
	c-0.0841522-0.0069885-0.1893311-0.0069885-0.3015289-0.0069885c-0.273468,0.0069885-0.6871948,0.0147095-0.8414612-0.0974731
	c-0.9396515-0.6247864-2.5945435-2.4900513-2.3981934-3.5348816c0.1402435-0.7573242,0.098175-7.5381775,0.0287476-15.6583557
	c-0.0287476-3.3581543-0.0497894-6.2689209-0.0357666-6.4575806c0.0841522-0.3232422,0.0210419-3.4857788,0.007019-4.1028442
	c0.0420837-3.2600098,4.1161957-325.7110596,4.9857025-330.2129211c0.6661682-3.457756,5.434494-9.6776199,7.5872498-12.3485489
	l-0.0420837,0.084137l1.0869141-1.3610992l0.0070038-0.0062943c8.8774872-11.129158,34.2477875-29.038414,34.5009613-29.2137222
	l0.1885986-0.1332321l-0.1402283-0.1893463c-1.619812-2.1878128-4.5369263-12.9158554-4.9716797-14.5223312
	c5.4906006-1.8996506,14.5153503,1.5153503,14.6065063,1.549675l0.3092346,0.1192398v-0.3366127
	c0-3.3308182-0.3092346-6.605526-0.5827332-9.0871582c-0.1542664-1.3954315-0.3085327-2.7417679-0.5118713-4.0467644
	c1.5349731,0.4978867,3.0713806,0.9894371,4.6140442,1.4803009c5.3293152,1.6822281,10.8409424,3.4282722,16.1001282,5.6027756
	c6.4154968,2.643589,12.6851501,6.2549133,19.1504211,11.0365829c0.9817505,0.7229233,1.795166,1.4101563,2.4753418,2.0966568
	c0.3583374,0.3793259,0.9466553,1.0448151,1.1009216,1.3463364c-4.487854,17.3412704-6.7668152,34.6131592-9.1572876,52.8162384
	c-0.6451416,4.9226074-1.3190308,10.0212097-2.0272522,15.0552673
	C324.6783752,148.7461548,324.0682983,158.3662415,324.0682983,168.7513885 M340.0709229,256.7129822
	c-1.4802551-4.1365356-11.0169373-43.4408569-12.4467163-51.2868652l-0.3092346-1.7180023
	c-0.5897217-3.3174896-1.5707397-8.8003693-2.790863-14.6976624v-20.2590637c0-10.3634033,0.6100464-19.9638519,1.816864-28.5258179
	c0.7145691-5.0341034,1.3807068-10.1327057,2.0328369-15.0622864c2.5812073-19.6546555,5.0278015-38.2307739,10.2722473-56.9667892
	c1.8589478,1.6471786,7.4967957,9.1853409,11.2693787,17.9997406c4.3265686,10.0905838,19.0452576,65.6696548,20.0620422,71.3152237
	c0.182312,1.0020599,0.7012329,3.7305145,1.4234924,7.5514679c2.9451294,15.5819244,9.8381653,52.072937,10.4061584,58.3075256
	c0.7012329,7.7415314,3.4927979,28.0061951,5.6168213,36.4980469c1.977417,7.9035034,5.4141235,42.921936,5.7710571,46.5472717
	c-4.3195496-0.7706299-26.3940735-2.8399658-42.6281433,3.7726135c-0.1465454,0.0637817-0.2650757,0.1682739-0.3709412,0.2874756
	C349.0115356,303.5267334,341.8443604,261.6566162,340.0709229,256.7129822 M393.3843384,306.9213562
	c-19.6272888,6.7808533-38.3359375,6.0585938-42.5783386,5.0411072c-0.3015442-0.0694275-0.4277649-0.3639526-0.4480896-0.6163635
	c-0.0217285-0.2601624,0.0694275-0.6037903,0.3842773-0.7292786c9.0822449-3.703186,20.0136414-4.6708679,28.5973206-4.6708679
	c7.0395813,0,12.4951172,0.6521301,14.0658875,0.9676819L393.3843384,306.9213562z"
      />
    </svg>
  );
}
